import React from 'react';
import { PopupOrPanel } from '../../components/popupsAndPanels/PopupAndPanels';
import { PUBLIC_SITE_URL } from 'appConstants';

type Props = {
  panelOpen: boolean;
  togglePanelOpen: React.Dispatch<React.SetStateAction<boolean>>;
  onContinue: any;
};

export const SubscriptionDoubleSubDiscountAlignPackages: React.FC<Props> = ({
  panelOpen,
  togglePanelOpen,
  onContinue,
}) => {
  return (
    <PopupOrPanel
      isPopup={true}
      isOpen={panelOpen}
      hdrTitle={'Double Subject Discount'}
      position="right"
      primaryBtnTxt="Continue"
      secondaryBtnTxt="Cancel"
      givenClass="SubscriptionDoubleSubDiscountModal"
      primaryBtnColor="BtnOrange"
      secondaryBtnColor="BtnGrey"
      handleClose={() => togglePanelOpen(false)}
      handlePrimaryBtn={() => onContinue()}
      handleSecondaryBtn={() => togglePanelOpen(false)}
      width={560}
    >
      <p>To access a double subject discount, you will need to align your packages. Contact <a href={`${PUBLIC_SITE_URL}/contact-us`} target="_blank" rel="noreferrer">Get Set 4 Education</a> for support.</p>
    </PopupOrPanel>
  );
};
